'use client';

import { c as _c } from "react/compiler-runtime";
import type { MarketId } from '@morpho-org/blue-sdk';
import { useDialogContext } from '@morpho-org/ui-v6/contexts';
import { Button } from '@repo/ui';
import { Close } from '@repo/ui/icons';
import { memo } from 'react';
import type { MarketLendWithdrawSource } from '@/lib/analytics/client/events';
import { ErrorServiceUnavailable } from '@/components/common/Error';
import SectionErrorBoundary from '../../SectionErrorBoundary';
import PositionManagerLendWithdrawDialogContent from './PositionManagerLendWithdrawDialogContent';
interface PositionManagerLendWithdrawDialogProps {
  marketId: MarketId;
  chainId: number;
  source: MarketLendWithdrawSource;
  onClose: () => void;
}

// The morpho-sdk + evm-simulation lend-withdraw flow needs no sandbox SimulationContext.
function PositionManagerLendWithdrawDialog(props) {
  const $ = _c(12);
  const {
    toggleDialog
  } = useDialogContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className="text-title-sm">Withdraw</span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== toggleDialog) {
    t1 = () => toggleDialog(false);
    $[1] = toggleDialog;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Close />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <div className="flex items-center justify-between gap-[16px]">{t0}<Button size="icon" onClick={t1} variant="secondary" aria-label="Close">{t2}</Button></div>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ErrorServiceUnavailable minHeight="360px" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props) {
    t5 = <SectionErrorBoundary fallback={t4}><PositionManagerLendWithdrawDialogContent {...props} /></SectionErrorBoundary>;
    $[7] = props;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <div className="gap-md flex flex-col dark:[--card:var(--accent)]" data-testid="lend-withdraw-dialog">{t3}{t5}</div>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
export default memo(PositionManagerLendWithdrawDialog);